<div class="no-associated-contact justify-content-center h-100">
    <div class="content h-100"> 
        <div class="content-icon">
            <i class="icon-edponline-Bra-055-2 custom-icon"></i>
        </div>  

        <p class="title"> 
            {{ "pt.edp.edponline.no.associated.contact.title" | translate }}  
        </p> 
        <p class="description">
            {{ "pt.edp.edponline.no.associated.contact.description" | translate }}  
        </p>        
        <p class="observation">
            {{ "pt.edp.edponline.no.associated.contact.observation" | translate }}  
        </p>

        <p class="number"> 
            {{ "pt.edp.edponline.no.associated.contact.call" | translate }}  
        </p>

        <a class="link" [attr.href]="hrefTel" [innerHtml]="'pt.edp.edponline.no.associated.contact.link' | translate"></a>

        <div class="custom-buttons">
            <div> 
                <button class="custom-button" [innerHtml]="'pt.edp.edponline.no.associated.contact.button.close' | translate" (click)="close()"></button>
            </div>
        </div>

    </div>
</div>